// extracted by mini-css-extract-plugin
export default {"isVertical":"RadioList_isVertical__mM4Zk"};